import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32102746"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "texturebackground__container",
  ref: "texturebackgroundContainer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "texturebackground",
      style: _normalizeStyle(_ctx.textureStyle)
    }, null, 4)
  ], 512))
}